const CONFIG = {
  ingresado:       { bg: '#fef3c7', color: '#92400e', label: 'Ingresado' },
  confirmado:      { bg: '#dbeafe', color: '#1e40af', label: 'Confirmado' },
  procesado:       { bg: '#e0f2fe', color: '#075985', label: 'Procesado' },
  asignado:        { bg: '#fef3c7', color: '#92400e', label: 'Asignado' },
  en_distribucion: { bg: '#ede9fe', color: '#5b21b6', label: 'En distribución' },
  entregado:       { bg: '#dcfce7', color: '#166534', label: 'Entregado' },
  no_entregado:    { bg: '#fee2e2', color: '#991b1b', label: 'No entregado' },
  reagendado:      { bg: '#fff7ed', color: '#c2410c', label: 'Reagendado' },
  anulado:         { bg: '#fecaca', color: '#7f1d1d', label: 'Anulado' },
}

export default function EstadoBadgeRemito({ estado }) {
  const cfg = CONFIG[estado] || { bg: '#f1f5f9', color: '#64748b', label: estado }
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'uppercase',
      background: cfg.bg,
      color: cfg.color,
    }}>
      {cfg.label}
    </span>
  )
}
